module.exports = __webpack_public_path__ + "img/liderancas.630cfb42.png";